export default __webpack_public_path__ + "static/media/pic1.e327e192.jpg";